import { ProfileComponent } from './profile.component';
import { ProfileService } from '@fuse/services/profile.service';
var ɵ0 = ProfileService;
var routes = [
    {
        path: 'profile',
        component: ProfileComponent,
        pathMatch: 'full',
        resolve: {
            data: ɵ0
        }
    }
];
var ProfileModule = /** @class */ (function () {
    function ProfileModule() {
    }
    return ProfileModule;
}());
export { ProfileModule };
export { ɵ0 };
